import {
  MainMetaMapSubject,
  MainMetaMapSubTopic,
  MainMetaMapTopic,
} from "@tsTypes/meta-schema";

export enum MockExamType {
  slMcPaper = "slMcPaper",
  hlMcPaper = "hlMcPaper",
  slLaPaper = "slLaPaper",
  hlLaPaper = "hlLaPaper",
}

export enum TestFormats {
  custom = "customTest",
  mockExam = "mockExam",
}

export type LimitType = "time" | "questions";

export type StepperTopicOption = {
  topicId: string;
  title: string;
  subTopics: {
    subTopicId: string;
    label: string;
  }[];
};

export type TestBuilderSubjectOptions = {
  [documentId: string]: MainMetaMapSubject["title"];
};

export type TestBuilderTopicOptions = {
  [documentId: string]: Omit<MainMetaMapTopic, "index" | "subjectDocumentId">;
};

export type TestBuilderSubTopicOptions = {
  [documentId: string]: Omit<MainMetaMapSubTopic, "index" | "subThemes">;
};
